import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sof5: FaireReviewEntity = {
  token: "review_sof5",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "product",
  productToken: "p_jjcrjr276j",
  reviewerName: "Susan",
  reviewerLocation: "Los Gatos, CA",
  stars: 5,
  reviewText: "Great product. Super cozy. Happy customers = happy us :)",
  reviewDate: "Apr 1, 2025",
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
